module.exports = __webpack_public_path__ + "static/media/img3.f0fc37d0.png";